import { capitalize } from 'lodash';

import { formatDate, formatPhoneNumber } from 'lib/helpers/utility';

const columns = [
  { field: 'id', headerName: 'ID' },
  { field: 'f_name', headerName: 'First Name', valueFormatter: ({ value }) => capitalize(value) },
  { field: 'l_name', headerName: 'Last Name', valueFormatter: ({ value }) => capitalize(value) },
  {
    field: 'dob',
    headerName: 'Date of Birth',
    valueFormatter: ({ value }) => {
      if (!value) {
        return 'No Date of Birth Given';
      }
      return formatDate(value);
    }
  },
  { field: 'email', headerName: 'Email' },
  {
    field: 'phone',
    headerName: 'Phone',
    valueFormatter: ({ value }) => formatPhoneNumber(value)
  },
  {
    field: 'status',
    headerName: 'Status',
    valueGetter: (params) => {
      return params?.data?.practicePatientLink?.status || 'inactive';
    },
    valueFormatter: ({ value }) => capitalize(value)
  }
];

export default columns;
